import { useQuery } from "@tanstack/react-query";
import { overview } from "@/app/overview";
import { Alert, EmptyState, Money, PageHeader, StatGrid, StatTile } from "@/ui";

/** 概览：主数据计数、北京时间当天的用量与毛利（docs/04 第 8 节）。队列深度、送达率趋势与告警随阶段 3 的 metrics 与阶段 4 的告警加入。 */
export function Overview() {
  const q = useQuery({ queryKey: ["overview"], queryFn: overview.get, refetchInterval: 60_000 });
  const d = q.data;
  const rate = d && d.today.message_count ? `${((d.today.delivered_count / d.today.message_count) * 100).toFixed(1)}%` : "—";
  return (
    <>
      <PageHeader title="运营概览" description="今日按北京时间从 usage_hourly 汇总，只含终态消息；金额为基准币种。" />
      {q.error && <Alert tone="danger" title="加载失败">{q.error.message}</Alert>}
      {d ? (
        <>
          <StatGrid columns={3}>
            <StatTile label="启用账号" value={d.accounts_active} />
            <StatTile label="启用通道" value={d.channels_active} />
            <StatTile label="今日消息" value={d.today.message_count} delta={{ text: `失败 ${d.today.failed_count}`, tone: d.today.failed_count ? "warn" : undefined }} />
          </StatGrid>
          <div style={{ height: "var(--space-4)" }} />
          <StatGrid columns={4}>
            <StatTile label="今日送达率" value={rate} delta={{ text: `送达 ${d.today.delivered_count}` }} />
            <StatTile label="今日售价" value={<Money micro={d.today.sell_base} />} />
            <StatTile label="今日成本" value={<Money micro={d.today.cost_base} />} />
            <StatTile label="今日毛利" value={<Money micro={d.today.sell_base - d.today.cost_base} />} delta={{ text: "售价减成本，基准币种", tone: d.today.sell_base - d.today.cost_base < 0 ? "down" : "up" }} />
          </StatGrid>
        </>
      ) : (
        !q.error && <EmptyState title="加载中" />
      )}
    </>
  );
}
